__turbopack_context__.v({
  "backgroundImage": "HomePanelWrapper-module-scss-module__BW3N8G__backgroundImage",
  "container": "HomePanelWrapper-module-scss-module__BW3N8G__container",
  "cssBackground": "HomePanelWrapper-module-scss-module__BW3N8G__cssBackground",
  "section": "HomePanelWrapper-module-scss-module__BW3N8G__section",
  "withBackground": "HomePanelWrapper-module-scss-module__BW3N8G__withBackground",
});
